import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { Dagger } from '../../common/notifications/NotificationsTrigger';
import { withNotifications } from '../../common/notifications/NotificationsContext';

const AttributesDisclaimer = withNotifications(
  ({ text, disclaimer, notifications }) => {
    const { disabled, show } = notifications;

    if (disabled || !disclaimer) {
      return <span className="attributes-large__value">{text}</span>;
    }

    return (
      <React.Fragment>
        <span
          className="attributes-large__value disclaimer"
          onClick={event => show(disclaimer, event)}>
          {text}
          <Dagger className={'attributes-large__disclosure'} />
        </span>
        <span className="show-for-sr">{disclaimer}</span>
      </React.Fragment>
    );
  }
);

const AttributesLarge = ({ attributes, selections }) => {
  const searchParams = new URLSearchParams({
    section: 'Trailering and Payload',
    engineOne: selections.engine,
    driveTypeOne: selections.driveType,
    bodyTypeOne: selections.bodyTypeId
  });

  if (attributes.length === 0) {
    return null;
  }

  return (
    <div className="attributes-large">
      <div className="attributes-large__items">
        {attributes.map(attribute => (
          <div key={attribute.id} className="attributes-large__item">
            <span className="attributes-large__label">
              {attribute.name}
              {attribute.unit && attribute.unit !== 'MPG' ? (
                <span className="attributes-large__unit">
                  {' '}
                  {attribute.unit}
                </span>
              ) : null}
            </span>
            <div className="attributes-large__value-container">
              <SvgIcon
                className="attributes-large__icon"
                name={attribute.imgSrc}
              />
              <AttributesDisclaimer
                text={`${attribute.value} `}
                disclaimer={attribute.disclosure}
              />
            </div>
          </div>
        ))}
      </div>
      <Link
        to={`/config/compare/capabilities?${searchParams.toString()}`}
        className="attributes-large__link stat-text-link"
        data-dtm="attributes">
        <Translate value="view.all.specs" />
      </Link>
    </div>
  );
};

export default AttributesLarge;
